"use client";
import t from "./index.es65.js";
import "react";
t.div`
  margin-bottom: 1rem;
`;
t.div`
  overflow-x: auto;
  position: relative;
`;
t.table`
  caption {
    display: none;
  }
  thead {
    th:not(:first-child) {
      background-color: #fff;
    }
  }
  tbody {
    background-color: #fff;
    & tr > th:first-child {
      background: #fff;
    }
  }
  & tr > th:first-child {
    position: sticky;
    left: 0;
  }
  td {
    text-align: right;
    color: #000;
  }
`;
//# sourceMappingURL=index.es35.js.map
